import { getAPIUrls } from 'src/helpers';

const apiRootPaths = {
  // New Dashboard
  DASHBOARD_UNREAD_MESSAGE_SERVICE: '/api/portal/v1/dashboard/count',
  DASHBOARD_UNREAD_MESSAGE_COUNT_SERVICE: '/api/portal/v1/communications/unreadMessageCount',

  // Administration
  AUTOCOMPLETE_CMS_FILE_SERVICE: '/api/portal/v1/administration/searchUploads',

  // Auth
  LOGIN_SERVICE: '/api/portal/v1/auth/login',
  LOGOUT_SERVICE: '/api/portal/v1/auth/logout',
  PINCODE_SERVICE: '/api/portal/v1/auth/two-way',
  USER_VALIDATE_SERVICE: '/api/portal/v1/auth/validate',
  LOGIN_SELECT_ROLE_SERVICE: '/api/portal/v1/auth/selectRole',
  GET_SSO_REDIRECT_URL: '/api/portal/v1/auth/getSsoRedirect',
  UPDATE_BANNAER_COOKIE: '/api/portal/v1/auth/updateBannerCookie',
  X_XSRF_TOKEN_SERVICE: '/api/portal/v1/XsrfToken/getAntiForgeryRequestToken',

  // Accounts
  ACCOUNTS_FETCH_EMPLOYERS_LOOKUP_VALUES: '/api/portal/v1/accounts/fetchEmployersLookupValues',
  ACCOUNTS_FETCH_CLIENT_LOOKUP_VALUES: '/api/portal/v1/accounts/fetchClientLookupValues',
  ACCOUNTS_GET_NEW_EMPLOYER_FORM: '/api/portal/v1/accounts/getNewEmployerForm',
  ACCOUNTS_CREATE_EMPLOYER: '/api/portal/v1/accounts/createEmployer',

  // Case Management
  CASES_GET_CASES: '/api/portal/v1/casemanagement/GetCases',
  CASES_GET_CASE_DETAIL: '/api/portal/v1/casemanagement/GetCaseDetail',
  CASES_GET_CASE_BPF: '/api/portal/v1/casemanagement/GetCaseBPFStatus',
  CASES_GET_COUNTRY_MAPPING: '/api/portal/v1/casemanagement/getCountryServiceMapping',
  CASES_GET_QVDATA_DETAIL: '/api/portal/v1/casemanagement/getCountryServiceFormDetail',
  CASES_GET_QVDATA_DETAIL_BY_ID: '/api/portal/v1/casemanagement/getCountryServiceFormDetailById',
  CASES_GET_QUESTIONNAIRE_LIST: '/api/portal/v1/casemanagement/getQuestionnaireList',
  CASES_GET_DETAILS_HEADER: '/api/portal/v1/casemanagement/getApplicantDetails',
  CASES_GET_FILTERS: '/api/portal/v1/casemanagement/getfilters',
  CASES_CASE_PHASES: '/api/portal/v1/casemanagement/casephase',
  CASES_GET_ACTIONS: '/api/portal/v1/casemanagement/getCaseActions',
  CASES_GET_MESSAGES_COUNT: '/api/portal/v1/casemanagement/getCaseMessagesCount',
  CASES_GET_DOCUMENTS_COUNT: '/api/portal/v1/casemanagement/getCaseDocumentsCount',
  CASES_GET_CONTACTS: '/api/portal/v1/casemanagement/getCaseContacts',
  CASES_SAVE_CASE_DETAIL: '/api/portal/v1/casemanagement/updateCaseDetail',
  CASES_SAVE_COUNTRY_MAPPING: '/api/portal/v1/casemanagement/updateCaseWithCountryRelatedDataId',
  CASES_SAVE_QVDATA_DETAIL: '/api/portal/v1/casemanagement/updateCountryServiceFormDetail',
  CASE_CREATE_QVDATA_DETAIL: '/api/portal/v1/casemanagement/createCountryServiceFormDetail',
  CASES_GET_STATUS_INFO: '/api/portal/v1/casemanagement/getCaseStatusInfo',
  CASES_GET_APPLICANT_TYPE_BY_COUNTRY: '/api/portal/v1/CaseManagement/getApplicationTypeByCountry?countryid=',
  CASES_GET_MENU: '/api/portal/v1/dashboard/getCaseDataMenu',
  CASES_GET_REFERESH_QUESTIONNAIRE: '/api/portal/v1/questionnaire/refreshquestionnairepage',

  // CMS
  CMS_CREATE_SSIORGRANIZER: '/api/portal/v1/cms/CreateSSIOrganizer',
  CMS_PERSIST_ORGANIZER: '/api/portal/v1/cms/PersistOrganizer',
  CMS_SUBMIT_ORGANIZER: '/api/portal/v1/cms/SubmitOrganizer',
  CMS_GET_SHOWORGANIZER: '/api/portal/v1/cms/ShowOrganizer',
  CMS_FILE_UPLOAD: '/api/portal/v1/cms/SaveAttachment',
  CMS_FILE_REMOVE: '/api/portal/v1/cms/RemoveAttachment',
  CMS_FILE_DOWNLOAD: '/api/portal/v1/cms/DownloadDocument',
  CMS_SAVE_GOACCESS_DETAILS: '/api/portal/v1/cms/SaveGOAccessDetails',
  ADMIN_GET_PACKAGE_FILE: '/api/portal/v1/cms/cmsDownloadPackageFile',
  ADMIN_GET_STATUS_FILE: '/api/portal/v1/cms/cmsDownloadStatusFile',
  QUESTIONNAIRE_GET_CARD: '/api/portal/v1/cms/questionnaireCard',
  ADMIN_GET_FILES: '/api/portal/v1/cms/GetCMSPackageResult',
  ADMIN_UPLOAD_CMS_SERVICE: '/api/portal/v1/cms/UploadCMSPackageFile',
  ADMIN_UPLOAD_DROPDOWNS_CMS_SERVICE: '/api/portal/v1/cms/GetDropDownValuesForUploadCMSPackageFile',
  ADMIN_DROPDOWNS_CMS_SERVICE: '/api/portal/v1/cms/GetDropDownValuesForCMSPackageResult',
  ADMIN_UPDATE_CMS_SERVICE: '/api/portal/v1/cms/UpdatePackageMetaData',
  GET_WORKPAPER_URL: '/api/portal/v1/cms/GenerateWorkPaperURL',
  DOWNLOAD_PREPROFORMA_XML: '/api/portal/v1/cms/downloadpreproformaXML',
  DOWNLOAD_ANSWERKEY_XML: '/api/portal/v1/cms/downloadanswerkeyXML',

  CMS_RELATED_LIST: '/api/portal/v1/cms/related/list',
  CMS_RELATED_DETAILS: '/api/portal/v1/cms/related/details',
  CMS_RELATED_UPSERT: '/api/portal/v1/cms/related/upsert',
  CMS_RELATED_DELETE: '/api/portal/v1/cms/related/delete',

  // Communications
  MESSAGING_INBOX_SERVICE: '/api/portal/v1/communications/inbox',
  MESSAGING_SENT_SERVICE: '/api/portal/v1/communications/sent',
  MESSAGING_DRAFTS_SERVICE: '/api/portal/v1/communications/drafts',
  MESSAGING_DETAILS_SERVICE: '/api/portal/v1/communications/message',
  MESSAGING_SAVEMESSAGE_SERVICE: '/api/portal/v1/communications/savemessage',
  MESSAGING_COUNT_SERVICE: '/api/portal/v1/communications/count',
  MESSAGING_DELETE_SERVICE: '/api/portal/v1/communications/delete',
  MESSAGING_DELETE_DRAFT_SERVICE: '/api/portal/v1/Communications/deleteDraftMessage',
  MESSAGING_FILTERS: '/api/portal/v1/communications/getFilters',
  MESSAGING_GET_CASE_CONTACT_INFO: '/api/portal/v1/communications/getCaseAndContactInfo',
  MESSAGING_AUTOCOMPLETE_PARTIES: '/api/portal/v1/communications/searchParties',
  MESSAGING_AUTOCOMPLETE_CASES: '/api/portal/v1/communications/searchCases',
  MESSAGING_UPLOAD_ATTACHMENT_SERVICE: '/api/portal/v1/communications/Upload',
  MESSAGING_DOWNLOAD_ATTACHMENT_SERVICE: '/api/portal/v1/communications/files',
  MESSAGING_ASSIGN_CASE_SERVICE: '/api/portal/v1/communications/assignCaseToMessage',

  // Consents
  CONSENT_GET_BY_DEF_KEY: '/api/portal/v1/consents/getConsentsByConsentDefinitionKey',
  CONSENT_SAVE_ACCEPTANCES: '/api/portal/v1/consents/saveConsentAcceptances',
  CONSENT_DOWNLOAD_SUMMARY: '/api/portal/v1/consents/downloadConsentsSummary',

  // Global Menu
  DASHBOARD_GLOBAL_MENU_COUNT: '/api/portal/v1/dashboard/globalMenuCount',

  // Dashboard
  DASHBOARD_DOCUMENTS: '/api/portal/v1/dashboard/getNewDocuments',
  DASHBOARD_GET_SLASTATUS: '/api/portal/v1/dashboard/getSLAStatus',
  DASHBOARD_GET_CASEDETAILS: '/api/portal/v1/dashboard/getDashboardCaseDetails',
  DASHBOARD_GET_CASES: '/api/portal/v1/dashboard/getCases',
  DASHBOARD_GET_CASES_STATUS: '/api/portal/v1/dashboard/caseStatusInfo',

  // Documents
  DOCUMENTS_GET_DOCUMENTS: '/api/portal/v1/documents/getdocuments',
  DOCUMENTS_CLIENTS: '/api/portal/v1/documents/getclients',
  DOCUMENTS_DOCUMENT_TYPES: '/api/portal/v1/documents/getdocumentypes',
  DOCUMENTS_EMPLOYEES: '/api/portal/v1/documents/getemployees',
  DOCUMENTS_FIELDS: '/api/portal/v1/documents/getdocumentmetadatabydocumenttype',
  DOCUMENTS_SAVE_UPLOAD: '/api/portal/v1/documents/savedocumentinformation',
  DOCUMENTS_FILTER: '/api/portal/v1/Documents/filterDocuments',
  DOCUMENTS_GET_FILTERS: '/api/portal/v1/Documents/filters',
  DOCUMENTS_OPEN: '/api/portal/v1/documents/openDocument',
  DOCUMENTS_DELETE: '/api/portal/v1/documents/deletedocument',
  DOCUMENTS_DELETE_WITH_CASE_DOCUMENT: '/api/portal/v1/documents/deleteDocumentWithCaseDocument',
  DOCUMENTS_VIEW_DETAILS: '/api/portal/v1/documents/getDocumentDetail',
  DOCUMENTS_GET_DETAILS_HEADER: '/api/portal/v1/documents/getDocumentDetailHeader',
  DOCUMENTS_SAVE_DOCUMENT_DETAIL: '/api/portal/v1/documents/updateDocumentDetail',
  DOCUMENTS_GET_DOCUMENT_UPLOAD_FORM: '/api/portal/v1/documents/getDocumentUploadForm',
  DOCUMENTS_UPLOAD_DOCUMENTS_FORM: '/api/portal/v1/documents/uploadDocumentsForm',
  DOCUMENTS_UPLOAD: '/api/portal/v1/documents/uploadDocuments',
  DOCUMENTS_GET_CASES_LOOKUP_VALUES: '/api/portal/v1/documents/getCaseLookupValues',
  DOCUMENTS_ADD_CASES: '/api/portal/v1/documents/addCasesToDocument',
  DOCUMENTS_CASE_DATA_FILTER: '/api/portal/v1/documents/filterDocumentForCaseDetail',
  DOCUMENTS_GET_CASE_LOOKUP_FILTER: '/api/portal/v1/documents/getCaseLookupByCaseNumber',

  // Employees
  EMPLOYEES_GET_EMPLOYEES: '/api/portal/v1/employees/getEmployees',
  EMPLOYEES_GET_EMPLOYEE_DETAIL_HEADER: '/api/portal/v1/employees/getEmployeeDetailHeader',
  EMPLOYEES_GET_EMPLOYEE_DETAIL: '/api/portal/v1/employees/getEmployeeDetails',
  EMPLOYEES_UPDATE_EMPLOYEE_DETAILS: '/api/portal/v1/employees/updateEmployeeDetails',
  EMPLOYEES_UPSERT_CONTACT_EMPLOYMENT_HISTORY_SALARY: '/api/portal/v1/employees/upsertContactEmploymentHistorySalary',

  // Profile
  PROFILE_GET_NAME: '/api/portal/v1/profile/getProfileName',
  PROFILE_GET_DETAILS: '/api/portal/v1/profile/getProfileDetails',
  PROFILE_SAVE_DETAILS: '/api/portal/v1/profile/updateProfileDetails',
  PROFILE_GET_CONTACT_EMPLOYMENT_HISTORY: '/api/portal/v1/profile/getContactEmploymentHistory',
  PROFILE_UPSERT_CONTACT_EMPLOYMENT_HISTORY: '/api/portal/v1/profile/upsertContactEmploymentHistory',
  PROFILE_UPSERT_CONTACT_EMPLOYMENT_HISTORY_SALARY: '/api/portal/v1/profile/upsertContactEmploymentHistorySalary',
  PROFILE_GET_RELATIONSHIP_CONTACT: '/api/portal/v1/profile/getRelationshipContact',

  // Questionnaire
  QUESTIONNAIRE_GET_PAGE: '/api/portal/v1/Questionnaire/questionnairePage',
  QUESTIONNAIRE_GET_DATA_COLLECT_PAGE: '/api/portal/v1/Questionnaire/questionnaireDataCollectPage',
  QUESTIONNAIRE_CASEDATACOLLECT_SAVE_PAGE: '/api/portal/v1/Questionnaire/saveCaseDataCollectQuestionnairePage',
  QUESTIONNAIRE_PROFILE: '/api/portal/v1/Questionnaire/getQuestionnaireProfile',
  QUESTIONNAIRE_PROFILE_LIST: '/api/portal/v1/questionnaire/profilerelated/list',
  QUESTIONNAIRE_PROFILE_DETAILS: '/api/portal/v1/questionnaire/profilerelated/details',
  QUESTIONNAIRE_PROFILE_DELETE: '/api/portal/v1/questionnaire/profilerelated/delete',
  QUESTIONNAIRE_TABLE_UPSERT: '/api/portal/v1/questionnaire/profilerelated/upsert',
  QUESTIONNAIRES_GET_REVIEW_SUMMARY_HTML: '/api/portal/v1/Questionnaire/questionnaireReviewSummaryHtml',

  // Required Actions
  REQUIRED_ACTIONS_GET_ACTIONS: '/api/portal/v1/requiredactions/getActionsRequired',
  REQUIRED_ACTIONS_GET_ACTIONS_PROFILE: '/api/portal/v1/requiredactions/getActionsRequiredProfile',
  REQUIRED_ACTIONS_GET_GROUP_IDS: '/api/portal/v1/requiredactions/getActionsRequiredGroupIDs',
  REQUIRED_ACTIONS_GET_TABLE_FILTERS: '/api/portal/v1/requiredactions/getTableFilters',
  REQUIRED_ACTIONS_GET_GROUP_TASK_DETAILS: '/api/portal/v1/requiredactions/getGroupTaskDetails',
  REQUIRED_ACTIONS_COMPLETE_TASKS: '/api/portal/v1/requiredactions/completeTasks',
  REQUIRED_ACTIONS_COMPLETE_DOCUMENT_TASKS: '/api/portal/v1/requiredactions/completeDocumentTask',
  REQUIRED_ACTIONS_SAVE_GROUP_TASK: '/api/portal/v1/requiredactions/saveGroupTask',
  REQUIRED_ACTIONS_TEMPLATE_DOWNLOAD: '/api/portal/v1/requiredactions/getDocumentTemplateData',
  REQUIRED_ACTIONS_DOCUMENT_DOWNLOAD: '/api/portal/v1/requiredactions/downloadTaskTemplate',
  REQUIRED_ACTIONS_DOCUMENT_CHECKBOX: '/api/portal/v1/requiredactions/saveDocumentTask',

  // Service Initiations
  ENGAGEMENTS_LIST: '/api/portal/v1/serviceinitiations/getengagementlist',
  SSI_GET_LIST: '/api/portal/v1/serviceinitiations/getssilist',
  SSI_GET_BATCH_LIST: '/api/portal/v1/serviceinitiations/getbatchsilist',
  SSI_GET_ENGAGEMENTLIST: '/api/portal/v1/serviceinitiations/getengagementlist',
  SSI_GET_INITIATIONTYPELIST: '/api/portal/v1/serviceinitiations/getinitiationtypelist',
  SSI_GET_EMPLOYEELIST_BY_NAME: '/api/portal/v1/serviceinitiations/getemployeelistbyname',
  SSI_GET_PASSPORT_COUNTRYLIST: '/api/portal/v1/serviceinitiations/getpassportcountrylist',
  SSI_GET_RELATIONSHIPSTATUS_LIST: '/api/portal/v1/serviceinitiations/getrelationshipstatus',
  SSI_GET_EMPLOYEETYPE_LIST: '/api/portal/v1/serviceinitiations/getemployeetypelist',
  SSI_GET_COUNTRY_LIST: '/api/portal/v1/serviceinitiations/getcountrylist',
  SSI_GET_EMPLOYEELIST_FORDROPDOWN: '/api/portal/v1/serviceinitiations/getemployeelistForDropdown',
  SSI_GET_DETAILS: '/api/portal/v1/serviceinitiations/ssiServiceEmployeeDetails',
  SSI_ADD_NEWEMPLOYEE: '/api/portal/v1/serviceinitiations/addNewEmployee',
  SSI_UPDATE_LINEMANAGER: '/api/portal/v1/serviceinitiations/updateSILineManager',
  SSI_EXPORT: '/api/portal/v1/serviceinitiations/exportssilist',
  SSI_GET_FILTERS: '/api/portal/v1/serviceinitiations/getFilters',
  SERVICEINIT_GET_CARD: '/api/portal/v1/ServiceInitiations/serviceInitiationCard',
  SERVICEINIT_GET_INTRO: '/api/portal/v1/ServiceInitiations/serviceInitiationIntro',
  SERVICEINIT_GET_SECTION: '/api/portal/v1/ServiceInitiations/serviceInitiationSection',
  SERVICEINIT_NEW: '/api/portal/v1/ServiceInitiations/newServiceInitiation',
  SERVICEINIT_SAVE: '/api/portal/v1/ServiceInitiations/saveServiceInitiation',
  SERVICEINIT_LOADINITIATION: '/api/portal/v1/ServiceInitiations/loadServiceInitiation',
  SERVICEINIT_CREATE_NEWEMPLOYEE: '/api/portal/v1/ServiceInitiations/createNewEmployeeRecord',
  SERVICEINIT_SAVE_NEWEMPLOYEE: '/api/portal/v1/ServiceInitiations/saveNewEmployeeRecord',
  SERVICEINIT_POLICIES: '/api/portal/v1/ServiceInitiations/%id%/services',
  SERVICEINIT_BATCH_UPLOAD: '/api/portal/v1/ServiceInitiations/uploadServiceInitiations',
  SERVICEINIT_BATCH_DOWNLOADTEMPLATE: '/api/portal/v1/ServiceInitiations/downloadTemplate',
  SERVICEINIT_BATCH_PROGRESS: '/api/portal/v1/ServiceInitiations/batchInitProgress',
  EMPLOYEES_GET_DUPLICATE: '/api/portal/v1/ServiceInitiations/getEmployeeforValidation',

  // SSI
  BATCH_INITIATION_UPLOAD: '/api/portal/v1/ssi/batchInitiationFileUpload',
  BATCH_TEMPLATE_DOWNLOAD: '/api/portal/v1/ssi/downloadBatchInitiationTemplate',
  BATCH_SUMMARY_DOWNLOAD: '/api/portal/v1/ssi/downloadBatchInitiationSummary',

  // Users
  PINCODE_FORGOT_PASS_SERVICE: '/api/portal/v1/users/forgot_password/two-way',
  RESET_PASS_SERVICE: '/api/portal/v1/users/forgot_password/reset',
  FORGOT_PASSWORD_SERVICE: '/api/portal/v1/users/forgot-password',
  ENGAGEMENT_USER_COUNTRY_LIST: '/api/portal/v1/users/getCountries',
  USERS_GET_ALL: '/api/portal/v1/users/getUsers',
  USERS_GET_ENGAGEMENT_OPTIONS: '/api/portal/v1/users/getEngagements',
  USERS_GET_USERDETAIL: '/api/portal/v1/users/getUserDetails?profileKey=',
  USERS_GET_SYSTEMROLES: '/api/portal/v1/users/getRoles',
  USERS_GET_COUNTRY_LIST: '/api/portal/v1/users/getCountries',
  USERS_USER_DETAIL_SAVE: '/api/portal/v1/users/saveuser',
  USERS_LINE_MANAGER: '/api/portal/v1/users/getProfilesByRoles',

  // Content Parser
  CONTENTPARSER_GET_DROPDOWN_OPTS: '/api/portal/v1/ServiceInitiations/getDropDownOptions',
  CONTENTPARSER_GET_TYPESUBTYPE_DROPDOWN_OPTS: '/api/portal/v1/documents/getDocumentTypeSubType',

  // Misc
  TEST_SERVICE: '/api/portal/v1/sometest',
  RESEND_CODE_SERVICE: '/api/portal/v1/sendagain',
  SAMPLE_TABLE_DATA: '',

  // What If
  WHATIF_GET_CALCULATIONS: '/api/portal/v1/whatifcalculator/calculate',
  WHATIF_DOWNLOAD_EXCEL: '/api/portal/v1/whatifcalculator/downloadExcel',
  WHATIF_GET_COUNTRIES_DICTIONARY: '/api/portal/v1/whatifcalculator/getCountriesDictionary',

  // Assignments
  ASSIGNMENTS_GET_ASSIGNMENTS: '/api/portal/v1/assignments/getAssignments',
  ASSIGNMENTS_FETCH_ASSIGNMENT_DETAIL_HEADER: '/api/portal/v1/assignments/fetchAssignmentDetailHeader',
  ASSIGNMENTS_UPDATE_ASSIGNMENT_DETAILS: '/api/portal/v1/assignments/updateAssignmentDetails',
  ASSIGNMENTS_FETCH_ASSIGNMENT_DETAIL: '/api/portal/v1/assignments/fetchAssignmentDetail',
  ASSIGNMENTS_FETCH_ASSIGNMENT_SERVICES: '/api/portal/v1/assignments/fetchAssignmentServices',
  ASSIGNMENTS_GET_ASSIGNMENT_SERVICE: '/api/portal/v1/assignments/getAssignmentService',
  ASSIGNMENTS_UPSERT_ASSIGNMENT_SERVICE: '/api/portal/v1/assignments/upsertAssignmentService',
  ASSIGNMENTS_DELETE_ASSIGNMENT_SERVICE: '/api/portal/v1/assignments/deleteAssignmentService',

  //Case data new URLS
  GET_DASHBOARD_CASE_DETAILS: '/api/portal/v1/dashboard/getDashboardCaseDetails',
  GET_DASHBOARD_CASE_COUNT_DETAILS: '/api/portal/v1/dashboard/headerCaseCount',
  NEW_MESSAGING_INBOX_SERVICE: '/api/portal/v1/communications/inbox',
  GET_DASHBOARD_ACTIVE_DOCUMENT_COUNT_SERVICE: '/api/portal/v1/dashboard/activeCaseDocumentCount',
};

const apiHosts = {
  azureDEV: {
    host: 'https://dev3-pathway.ey.com/IMLAPI',
  },
  azureDEV2: {
    host: 'https://dev4-pathway.ey.com/IMLAPI',
  },
  azureDEV3: {
    host: 'https://dev5-pathway.ey.com/IMLAPI',
  },
  azureDEVPOC: {
    host: 'https://dev-poc-pathway.ey.com/IMLAPI',
  },
  azureQA: {
    host: 'https://qa3-pathway.ey.com/IMLAPI',
  },
  azureQA2: {
    host: 'https://qa4-pathway.ey.com/IMLAPI',
  },
  azureQA3: {
    host: 'https://qa5-pathway.ey.com/IMLAPI',
  },
  azureQAPOC: {
    host: 'https://qa-poc-pathway.ey.com/IMLAPI',
  },
  azureUAT: {
    host: 'https://uat3-pathway.ey.com/IMLAPI',
  },
  azureUAT2: {
    host: 'https://uat4-pathway.ey.com/IMLAPI',
  },
  azureUATDE: {
    host: 'https://uat-pathway-eu.ey.com/IMLAPI',
  },
  azureSTG: {
    host: 'https://stg3-pathway.ey.com/IMLAPI',
  },
  azureDEMO: {
    host: 'https://demo2-pathway.ey.com/IMLAPI',
  },
  azureDEMOEU: {
    host: 'https://demoeu-pathway.ey.com/IMLAPI',
  },
  azurePROD: {
    host: 'https://pathway.ey.com/IMLAPI',
  },
  azurePRODDE: {
    host: 'https://pathway-eu.ey.com/IMLAPI',
  },
  local: {
    host: 'https://localhost:44336',
    overrides: {
      TEST_SERVICE: 'http://someotherurl.com/api/portal/v1/sometest',
    },
  },
};

const targetEnv =
  window && window.BUILD_API_URL && window.BUILD_API_URL !== 'API_URL_PLACEHOLDER' ? window.BUILD_API_URL : process.env.TARGET_ENV;
const { host, overrides } = apiHosts[targetEnv];
const serviceURLS = getAPIUrls(host, apiRootPaths, overrides);

export { host, apiRootPaths };
export default serviceURLS;
